// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"148":"c3f7dfd8","486":"f80d0824","489":"4d7f193b"}[chunkId] + ".chunk.css";
};